module.exports = __webpack_public_path__ + "static/Soleo1905-16a830e49918a86b6b78d9164c7eae6d.jpg";